<template>
  <div class="hello">
    <img alt="Vue logo" src="../assets/logo.png" style="width:200px; height:auto;">
    <div class="module">
      <h1>安雷科技</h1>
      <h3>用于公司产品演示、公司内部测试试用。</h3>
      <div style="width:380px; margin-top:30px;">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="60px">
          <el-form-item label="账号" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input v-model="ruleForm.password"></el-input>
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
      </div>

    </div>
    <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2022101782号-2</a>
    <p style="font-size:10px; color:#ececec" v-if="isHide">账号：adminTest 密码： abc!123456</p>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data () {
    return {
      isHide: false,
      ruleForm: {
        name: '',
        password: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入', trigger: 'blur'},
        ],
        password: [
          {required: true, message: '请输入', trigger: 'blur'},
        ],
      }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.name !== 'adminTest' || this.ruleForm.password !== 'abc!123456') {
            this.$message.error('账号密码错误~');
            return false
          }
          localStorage.setItem('loginStatus', true)
          setTimeout(() => {
            this.$router.push({path: '/home'})
          }, 600)
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h3 {
  margin:0;
}
.hello {
  display: flex;
  flex-direction: column;
  align-items: center;
  height:100%;
}
.module {
  text-align: center;
  flex:1;
  display: flex;
  flex-direction: column;
  align-items: center;
  /*padding-left:40px;*/
  /*box-sizing: border-box;*/
}
h1 {
  font-size:36px;
}
h3 {
  font-size:30px;
}
.hello a {
  text-decoration: none;
  color:#999;
}
</style>



// WEBPACK FOOTER //
// src/view/Login.vue